<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
    style="background-color: white;"
  >
    <CSidebarBrand class="d-md-down-none mt-3" to="/" style="background-color: white;">
      <img src="../assets/img/status-up.png" :height="30" alt="Dashboard of Interviewrr.ai"/> <label class="custom-20px-700 ml-2">MyHR Solutions</label>
     
    </CSidebarBrand>

    <!-- <CRenderFunction flat :content-to-render="$options.nav" class="font-color-171717"/> -->
    <CRenderFunction flat :content-to-render="selectedNavigationMenu" /> 
    <!-- <CSidebarMinimizer
      class="d-md-down-none font-color-171717"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    >Logout</CSidebarMinimizer>-->
    <div class="mt-auto">
      <CButton class="mb-2" v-on:click="SignOut()"><img style="max-width:30px" src="../assets/img/logout.png" alt="Interviewrr.ai icon logout"/>Logout</CButton>
    </div>
  </CSidebar>
</template>

<script>
import navStaff from './_navStaff'
import navHR from './_navHR'

export default {
  name: 'TheSidebar',
  navStaff,
  navHR,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  },
  data() {
    return {
      user: null,
      email: '',
      selectedNavigationMenu: [],
    };
  },
  async mounted() {
        this.GetInfoUser();
    },
  methods:
  {
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.$router.push("/Login");
          }
        });
    },
    async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.userType = this.user.userType;
                    this.getNavigationMenu(this.userType);
                } else {
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                console.error("Error fetching user info:", error);
            }
        },
        getNavigationMenu(userType) {
      if (userType === "Staff") {
        this.selectedNavigationMenu = navStaff;
      } else {
        this.selectedNavigationMenu = navHR;
      }
    }
  }
}
</script>
